import { render, staticRenderFns } from "./change-current-client.vue?vue&type=template&id=7010a817&scoped=true&lang=pug&"
import script from "./change-current-client.vue?vue&type=script&lang=ts&"
export * from "./change-current-client.vue?vue&type=script&lang=ts&"
import style0 from "./change-current-client.vue?vue&type=style&index=0&id=7010a817&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7010a817",
  null
  
)

export default component.exports